import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/auth/Login.vue";
import OfflineHome from "../views/auth/OfflineHome.vue";
import GetAccount from "../views/auth/GetAccount.vue";
import Pusher from "../views/auth/Pusher.vue";
import SelectType from "../views/auth/SelectType.vue";
import SignupClient from "../views/auth/SignupClient.vue";
import LegalPage from "../views/legal/LegalPage.vue";
import SignupState from "../views/auth/SignupState.vue";
import SignupHmo from "../views/auth/SignupHmo.vue";
import SignupProvider from "../views/auth/SignupProvider.vue";
import SignupAgency from "../views/auth/SignupAgency.vue";
import OnboardClient from "../views/onboarding/OnboardClient.vue";
import AllDashboard from "../views/Dashboard.vue";
import Dashboard from "../views/clients/Dashboard.vue";
import Subscribe from "../views/clients/Subscribe.vue";
import SubscribeSuccess from "../views/clients/SubscribeSuccess.vue";
import AddClientAgency from "../views/clients/AddClientAgency.vue";
import AddClientFormal from "../views/clients/AddClientFormal.vue";
import AddClientAgencyOffline from "../views/clients/offline/AddClientAgencyOffline.vue";
import AddClientEmployeeOffline from "../views/clients/offline/AddClientEmployeeOffline.vue";
import ALLEnrolleesOfflineEmployee from "../views/clients/offline/ALLEnrolleesOfflineEmployee.vue";
import AddClientFormVoluntary from "../views/clients/AddClientFormVoluntary.vue";
import EditOfflineEmployee from "../views/clients/offline/EditOfflineEmployee.vue";
import AddClientProvider from "../views/clients/AddClientProvider.vue";
import ManageClientsEmployee from "../views/clients/ManageClientsEmployee.vue";
import SingleClient from "../views/clients/SingleClient.vue";
import SinglePatient from "../views/clients/SinglePatient.vue";
import EnrolleeSlip from "../views/clients/EnrolleeSlip.vue";
import SlipsMDA from "../views/clients/SlipsMDA.vue";
import VerifiedEnrollee from "../views/clients/VerifiedEnrollee.vue";
import SingleClientBiometrics from "../views/clients/SingleClientBiometrics.vue";
import SingleClientCaptureSignature from "../views/clients/SingleClientCaptureSignature.vue";
import SingleClientSelectSector from "../views/clients/SingleClientSelectSector.vue";
import SingleClientHealthFacility from "../views/clients/SingleClientHealthFacility.vue";
import SingleClientEnrolmentSuccess from "../views/clients/SingleClientEnrolmentSuccess.vue";
import ViewClientsProvider from "../views/clients/ViewClientsProvider.vue";
import ViewClientsAgency from "../views/clients/ViewClientsAgency.vue";
import EnrolleeFeedbacks from "../views/clients/EnrolleeFeedbacks.vue";
import ProviderDashboard from "../views/providers/Dashboard.vue";
import UploadDocumentsManager from "../views/providers/UploadDocumentsManager.vue";
import UploadDocumentsManagerJSON from "../views/providers/UploadDocumentsManagerJSON.vue";
import HDashboard from "../views/hmos/Dashboard.vue";
import ListProviders from "../views/providers/ListProviders.vue";
import ListTPAs from "../views/tpas/ListTPAs.vue";
import SingleTPA from "../views/tpas/SingleTPA.vue";
import EditTPA from "../views/tpas/EditTPA.vue";
import AddClientTPA from "../views/tpas/AddClientTPA.vue";
import ViewClientsTPA from "../views/tpas/ViewClientsTPA.vue";
import AddOfficers from "../views/tpas/AddOfficers.vue";
import SingleProvider from "../views/providers/SingleProvider.vue";
import ChangePasswordEmployee from "../views/employees/ChangePasswordEmployee.vue";
import SingleEmployee from "../views/employees/SingleEmployee.vue";
import AddEmployee from "../views/employees/AddEmployee.vue";
import Employee from "../views/employees/Employee.vue";
import TPADashboard from "../views/tpas/TPADashboard.vue";
import TPAData from "../views/tpas/TPAData.vue";
import TPAEmployeeDashboard from "../views/tpas/TPAEmployeeDashboard.vue";
import AddEmployeeState from "../views/employees/AddEmployeeState.vue";
import ViewEmployees from "../views/employees/ViewEmployees.vue";
import ViewEncounters from "../views/shis/ViewEncounters.vue";
import EncounterStatistics from "../views/shis/EncounterStatistics.vue";
import AddDependents from "../views/dependents/AddDependents.vue";
import AddAdditionalDependents from "../views/dependents/AddAdditionalDependents.vue";
import MyDependents from "../views/dependents/MyDependents.vue";
import SingleDependent from "../views/dependents/SingleDependent.vue";
import AddPlan from "../views/plans/AddPlan.vue";
import Plans from "../views/plans/Plans.vue";
import Funds from "../views/funds/Funds.vue";
import PaymentOrdersClaims from "../views/funds/PaymentOrdersClaims.vue";
import PaymentOrdersCap from "../views/funds/PaymentOrdersCap.vue";
import StateDashboard from "../views/shis/StateDashboard.vue";
import DashboardOnly from "../views/shis/DashboardOnly.vue";
import DashboardSlideshow from "../views/shis/DashboardSlideshow.vue";
import AddClaim from "../views/claims/AddClaim.vue";
import AddClaimSecondary from "../views/claims/AddClaimSecondary.vue";
import EditClaim from "../views/claims/EditClaim.vue";
import UploadClaimDocuments from "../views/claims/UploadClaimDocuments.vue";
import ProvidersClaims from "../views/claims/ProvidersClaims.vue";
import ClaimsStatistics from "../views/claims/ClaimsStatistics.vue";
import AllClaims from "../views/claims/AllClaims.vue";
import ClaimsbyProvider from "../views/claims/ClaimsbyProvider.vue";
import ManageClaimsProvider from "../views/claims/ManageClaimsProvider.vue";
import SingleClaim from "../views/claims/SingleClaim.vue";
import ServiceProcessing from "../views/claims/ServiceProcessing.vue";
import AddReferral from "../views/claims/AddReferral.vue";
import Allreferrals from "../views/claims/Allreferrals.vue";
import SingleReferral from "../views/claims/SingleReferral.vue";
import ChangeFacility from "../views/others/ChangeFacility.vue";
import RequestCorridor from "../views/others/RequestCorridor.vue";
import AllCorridors from "../views/others/AllCorridors.vue";
import TransferofHCPRequests from "../views/others/TransferofHCP.vue";

import QaDashboard from "../views/others/QaDashboard.vue";
import AddAccreditationItems from "../views/others/AddAccreditationItems.vue";
import QualityAssurance from "../views/others/QualityAssurance.vue";
import MakeAccreditationItem from "../views/others/MakeAccreditationItem.vue";
import QualityAssuranceItemsMntIssues from "../views/others/QualityAssuranceItemsMntIssues.vue";
import SingleAccreditation from "../views/others/SingleAccreditation.vue";
import ServiceSummaryForm from "../views/services/ServiceSummaryForm.vue";
import DetailsofTreatment from "../views/services/DetailsofTreatment.vue";
import SingleServiceSummary from "../views/services/SingleServiceSummary.vue";
import ManageDrug from "../views/drugs/ManageDrug.vue";
import ManageService from "../views/drugs/ManageService.vue";
import CatalogItemUsage from "../views/drugs/CatalogItemUsage.vue";
import AddComplaint from "../views/complaints/AddComplaint.vue";
import MyComplaints from "../views/complaints/MyComplaints.vue";
import SingleComplaint from "../views/complaints/SingleComplaint.vue";
import TicketStatistics from "../views/complaints/TicketStatistics.vue";
import AddRecord from "../views/ehr/AddRecord.vue";
import AddRecordOffline from "../views/ehr/AddRecordOffline.vue";
import MyRecords from "../views/ehr/MyRecords.vue";
import AddInventory from "../views/inventories/AddInventory.vue";
import MyInventories from "../views/inventories/MyInventories.vue";
import AddAgency from "../views/providers/AddAgency.vue";
import Settings from "../views/auth/Settings.vue";
import EditUser from "../views/auth/EditUser.vue";
import AgencySettingsPage from "../views/auth/AgencySettingsPage.vue";
import ManagePlans from "../views/plans/ManagePlans.vue";
import EditProvider from "../views/providers/EditProvider.vue";
import ClientFunds from "../views/funds/ClientFunds.vue";
import SingleTransaction from "../views/funds/SingleTransaction.vue";
import SingleTransactionPayment from "../views/funds/SingleTransactionPayment.vue";
import LetterForPayment from "../views/funds/LetterForPayment.vue";
import Doctor from "../views/employees/Doctor.vue";
import Nurse from "../views/employees/Nurse.vue";
import Receptionist from "../views/employees/Receptionist.vue";
import Laboratorist from "../views/employees/Laboratorist.vue";
import Pharmacist from "../views/employees/Pharmacist.vue";
import Accountant from "../views/employees/Accountant.vue";
import Appointments from "../views/appointments/Appointments.vue";
import SingleAppointment from "../views/appointments/SingleAppointment.vue";
import VideoCall from "../views/appointments/VideoCall.vue";
import MDApage from "../views/shis/MDApage.vue";
import SingleMDA from "../views/shis/SingleMDA.vue";
import ViewActivities from "../views/shis/ViewActivities.vue";
import VendorEmployeeDashboard from "../views/procurement/VendorEmployeeDashboard.vue";
import Vendors from "../views/procurement/Vendors.vue";
import WardManager from "../views/shis/WardManager.vue";
import DataExport from "../views/shis/DataExport.vue";
import FilterUserProvider from "../views/shis/components/FilterUserProvider.vue";
import FilterUserDate from "../views/shis/components/FilterUserDate.vue";
import BulkSMS from "../views/shis/components/BulkSMS.vue";
import DuplicateUsers from "../views/clients/DuplicateUsers.vue";
import DuplicateDependents from "../views/clients/DuplicateDependents.vue";
import DBCleaner from "../views/shis/DBCleaner.vue";
import DBQuery from "../views/shis/DBQuery.vue";
import extraData from "../views/clients/extraData";
import EcounterPatientPage from "../views/shis/components/EncounterPatientPage.vue";
import disabledUser from "../views/clients/disabledUser";
import ManageDiagnosis from "../views/shis/ManageDiagnosis.vue";
import ChatWithHiva from "../views/others/ChatWithHiva.vue";
import AuthorizationCode from "../views/claims/AuthorizationCode.vue";
import SingleAuthorizationCode from "../views/claims/SingleAuthorizationCode.vue";
import AuthorizationCodeStatistics from "../views/claims/AuthorizationCodeStatistics.vue";
import UploadEnrolleesCSV from "../views/clients/UploadEnrolleesCSV.vue";
import RateFacilityPage from "../views/providers/RateFacilityPage.vue";
import EncounterbyDiagnosis from "../views/shis/components/EncounterbyDiagnosis.vue";

//wallet
import CreateWallet from "../views/shis/CreateWallet.vue";
import MakePaymentTransfer from "../views/shis/MakePaymentTransfer.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/",
    component: Login,
  },
  {
    path: "/activate-account",
    component: GetAccount,
  },
  // Privacy Policy, Terms of Use, Cookie Policy (public; text in views/legal/policies.js)
  { path: "/legal", component: LegalPage, meta: { legal: "hub" } },
  { path: "/privacy", component: LegalPage, meta: { legal: "privacy" } },
  { path: "/privacy-policy", redirect: "/privacy" },
  { path: "/terms", component: LegalPage, meta: { legal: "terms" } },
  { path: "/terms-of-use", redirect: "/terms" },
  { path: "/terms-and-conditions", redirect: "/terms" },
  { path: "/cookies", component: LegalPage, meta: { legal: "cookies" } },
  { path: "/cookie-policy", redirect: "/cookies" },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },

  {
    path: "/pusher",
    component: Pusher,
  },
  {
    path: "/messages/:id?",
    component: () => import(/* webpackChunkName: "chat" */ "../chat/views/Messages.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/select-type",
    component: SelectType,
  },
  {
    path: "/signup-clientOFF",
    component: SignupClient,
  },
  {
    path: "/signup-stateoff",
    component: SignupState,
  },
  {
    path: "/signup-tpaOFF",
    component: SignupHmo,
  },
  {
    path: "/signup-providerOFF",
    component: SignupProvider,
  },
  {
    path: "/signup-agencyOFF",
    component: SignupAgency,
  },
  {
    path: "/onboard-client",
    component: OnboardClient,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/offline-home",
    component: OfflineHome,
  },
  {
    path: "/user-settings",
    component: Settings,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/edit-user/:id",
    component: EditUser,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/agency-settings",
    component: AgencySettingsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage-plans",
    component: ManagePlans,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/edit-provider/:id",
    component: EditProvider,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dashboard",
    component: AllDashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/client-dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/subscribe/:id",
    component: Subscribe,
  },
  {
    path: "/subscribe-success/:id",
    component: SubscribeSuccess,
  },
  {
    path: "/add-client-agency",
    component: AddClientAgency,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-client-formal",
    component: AddClientFormal,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/self-enrollment",
    component: AddClientFormVoluntary,
    // meta: {
    //     requiresAuth: true,
    //   },
  },
  {
    path: "/add-client-offline",
    component: AddClientAgencyOffline,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/offline-sync",
    component: ALLEnrolleesOfflineEmployee,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/edit-offline",
    component: EditOfflineEmployee,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage-extra",
    component: extraData,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/disabled-users",
    component: disabledUser,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/add-client/employee-offline",
    component: AddClientEmployeeOffline,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-client-provider",
    component: AddClientProvider,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage-clients",
    component: ManageClientsEmployee,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/client/:id",
    component: SingleClient,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/patient/:type/:id",
    component: SinglePatient,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/enrollee_slip/:id",
    component: EnrolleeSlip,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/mda_slips/:id",
    component: SlipsMDA,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/verify-user/:id",
    component: VerifiedEnrollee,
    meta: {
      requiresAuth: false,
    },
  },
  {
    // Export "QR Code Link" column: /verify-user/client/<users.id> or /verify-user/dependant/<dependants.id>
    path: "/verify-user/:type(client|dependant)/:id",
    component: VerifiedEnrollee,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/client/biometrics/:id",
    component: SingleClientBiometrics,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/client/capture-signature/:id",
    component: SingleClientCaptureSignature,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/client-select-sector/:id",
    component: SingleClientSelectSector,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/client-select-facility/:id",
    component: SingleClientHealthFacility,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/client-submit-success/:id",
    component: SingleClientEnrolmentSuccess,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/view-clients-provider",
    component: ViewClientsProvider,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/view-clients-agency",
    component: ViewClientsAgency,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/provider-dashboard",
    component: ProviderDashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/hmo-dashboard",
    component: HDashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/my-providers",
    component: ListProviders,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/my-tpas",
    component: ListTPAs,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/tpa/:id",
    component: SingleTPA,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/edit-tpa/:id",
    component: EditTPA,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/provider-:id",
    component: SingleProvider,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/employee/:id",
    component: SingleEmployee,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/password-employee/:id",
    component: ChangePasswordEmployee,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/state-dashboard",
    component: StateDashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dashboard-view",
    component: DashboardOnly,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dashboard-slideshow",
    component: DashboardSlideshow,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/mda-manager",
    component: MDApage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/mda/:id",
    component: SingleMDA,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/all-activities",
    component: ViewActivities,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/vendor-employee-dashboard",
    component: VendorEmployeeDashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/procurement/vendors",
    component: Vendors,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/procurement/orders",
    component: () => import("../views/procurement/Orders.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/procurement/orders/:id",
    component: () => import("../views/procurement/OrderDetails.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/marketplace",
    component: () => import("../views/marketplace/Marketplace.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/marketplace/products/:id",
    component: () => import("../views/marketplace/ProductDetail.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/marketplace/cart",
    component: () => import("../views/marketplace/Cart.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/vendor/signup",
    component: () => import("../views/marketplace/VendorSignup.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/vendor/products",
    component: () => import("../views/marketplace/VendorProducts.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/vendor/account",
    component: () => import("../views/marketplace/VendorAccount.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/marketplace/admin",
    component: () => import("../views/marketplace/MarketplaceAdmin.vue"),
    meta: { requiresAuth: true },
  },
  // Facility assessments stored in hefrias (backend app/Hefrias/CLAUDE.md)
  {
    path: "/assessments",
    component: () => import("../views/assessments/Assessments.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/assessments/forms/:id",
    component: () => import("../views/assessments/FillAssessment.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/assessments/submissions/:id",
    component: () => import("../views/assessments/AssessmentDetail.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/assessments/links",
    component: () => import("../views/assessments/HefriasLinks.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/ward-manager",
    component: WardManager,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/export-data",
    component: DataExport,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/enrollee-feedback",
    component: EnrolleeFeedbacks,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/export-date",
    component: FilterUserDate,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/export-provider",
    component: FilterUserProvider,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/provider/add-employee/:id",
    component: AddEmployee,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/employee-dashboard",
    component: Employee,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/tpa-dashboard",
    component: TPADashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/tpa-data",
    component: TPAData,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/encounter/:id",
    component: EcounterPatientPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/tpa-employee-dashboard",
    component: TPAEmployeeDashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-officers",
    component: AddOfficers,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/view-clients-tpa",
    component: ViewClientsTPA,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-client-tpa",
    component: AddClientTPA,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-employee-state",
    component: AddEmployeeState,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/my-employees",
    component: ViewEmployees,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/my-encounters",
    component: ViewEncounters,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/encounter-statistics",
    component: EncounterStatistics,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-dependent/:id",
    component: AddDependents,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-additional-dependent/:id",
    component: AddAdditionalDependents,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/my-dependents",
    component: MyDependents,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dependent/:id",
    component: SingleDependent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-plan",
    component: AddPlan,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/plans",
    component: Plans,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/fund-manager",
    component: Funds,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/payment-claims",
    component: PaymentOrdersClaims,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/payment-capitations",
    component: PaymentOrdersCap,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-claim",
    component: AddClaim,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/add-claim/:id",
    component: AddClaimSecondary,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/all-referrals",
    component: Allreferrals,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/referral/:id",
    component: SingleReferral,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/edit-claim/:id",
    component: EditClaim,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/service-processing-form/:id",
    component: ServiceProcessing,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-referral",
    component: AddReferral,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/transfer-of-hcp",
    component: ChangeFacility,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/request-corridor",
    component: RequestCorridor,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/all-corridors",
    component: AllCorridors,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/change-facility-requests",
    component: TransferofHCPRequests,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/qa-dashboard",
    component: QaDashboard,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/accreditation-items",
    component: AddAccreditationItems,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/quality-assurance",
    component: QualityAssurance,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/make-accreditation-item/:id",
    component: MakeAccreditationItem,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/quality-assurance-items-management",
    component: QualityAssuranceItemsMntIssues,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/accreditation/:id",
    component: SingleAccreditation,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/service-summary-form",
    component: ServiceSummaryForm,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/details-of-treatment/:id",
    component: DetailsofTreatment,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/single-service-summary",
    component: SingleServiceSummary,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage-drugs",
    component: ManageDrug,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage-services",
    component: ManageService,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/price-list/:type(drug|service)/:id",
    component: CatalogItemUsage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/providers-claims",
    component: ProvidersClaims,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/claim/:id",
    component: SingleClaim,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/all-claims-facility",
    component: ManageClaimsProvider,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/claims-statistics",
    component: ClaimsStatistics,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/all-claims",
    component: AllClaims,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/all-claims/:id",
    component: ClaimsbyProvider,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/all-referrals",
    component: Allreferrals,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/upload-claims-docs/:id",
    component: UploadClaimDocuments,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-complaint",
    component: AddComplaint,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/upload-docs",
    component: UploadDocumentsManager,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/upload-docs-json",
    component: UploadDocumentsManagerJSON,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/my-complaints",
    component: MyComplaints,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/ticket-statistics",
    component: TicketStatistics,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/complaint/:id",
    component: SingleComplaint,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-record",
    component: AddRecord,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-record-offline",
    component: AddRecordOffline,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/list-records",
    component: MyRecords,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-inventory",
    component: AddInventory,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/telemedicine/network",
    component: () => import("../views/telemedicine/TelemedicineNetwork.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/teleconsult/:id",
    component: () => import("../views/telemedicine/TeleconsultJoin.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/teleconsult/:id/call",
    component: () => import("../views/appointments/VideoCall.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/join-telemedicine/:token",
    component: () => import("../views/telemedicine/JoinTelemedicine.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/telemedicine",
    component: () => import("../views/telemedicine/TelemedicineConsultations.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage-appointments",
    component: Appointments,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/appointment/:id",
    component: SingleAppointment,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/video-call/:meetingCode",
    component: VideoCall,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/my-inventories",
    component: MyInventories,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/add-agency",
    component: AddAgency,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/my-funds",
    component: ClientFunds,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/transaction/:id",
    component: SingleTransaction,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/payment/transaction/:id",
    component: SingleTransactionPayment,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/letter/:id",
    component: LetterForPayment,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/personnel",
    component: Doctor,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/nurse",
    component: Nurse,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/receptionist",
    component: Receptionist,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/laboratorist",
    component: Laboratorist,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pharmacist",
    component: Pharmacist,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/accountant",
    component: Accountant,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/manage-diagnosis",
    component: ManageDiagnosis,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/authorization-code",
    component: AuthorizationCode,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/authorization-code/:id",
    component: SingleAuthorizationCode,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/authorization-code-statistics",
    component: AuthorizationCodeStatistics,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/bulk-sms",
    component: BulkSMS,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/chat-with-hiva",
    component: ChatWithHiva,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/db-cleaner",
    component: DBCleaner,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/duplicate",
    component: DuplicateUsers,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/duplicate-dependent",
    component: DuplicateDependents,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/db-query",
    component: DBQuery,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/upload-enrollee/csv",
    component: UploadEnrolleesCSV,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/rate-facility/:id",
    component: RateFacilityPage,
    meta: {
      requiresAuth: false,
    },
  },

  {
    path: "/encounter-chart",
    component: EncounterbyDiagnosis,
    meta: {
      requiresAuth: false,
    },
  },

  {
    path: "/create-wallet/:id",
    component: CreateWallet,
    meta: {
      requiresAuth: false,
    },
  },

  {
    path: "/transfer/:type/:id",  //type = claims, interstate, capitation 
    component: MakePaymentTransfer,
    meta: {
      requiresAuth: false,
    },
  },
  // Enrollee and provider self-service (from claimify-front)
  {
    path: "/self-service-auth",
    component: () => import("../views/others/SelfServiceLanding.vue"),
  },
  {
    path: "/self-service-auth/enrollee",
    component: () => import("../views/others/SelfServiceAuth.vue"),
  },
  {
    path: "/self-service-auth/provider",
    component: () => import("../views/others/SelfServiceProvider.vue"),
  },
  {
    path: "/help",
    component: () => import("../views/others/SelfServiceLanding.vue"),
  },
  {
    path: "/self-service",
    component: () => import("../views/others/SelfService.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  // Reports: health check, executive summary, audit log, facility risk
  {
    path: "/system-health",
    component: () => import(/* webpackChunkName: "reports" */ "../views/reports/SystemHealth.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/executive-summary",
    component: () => import(/* webpackChunkName: "reports" */ "../views/reports/ExecutiveSummary.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/audit-log",
    component: () => import(/* webpackChunkName: "reports" */ "../views/reports/AuditLog.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/facility-risk",
    component: () => import(/* webpackChunkName: "reports" */ "../views/reports/FacilityRisk.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  // Analytics: call centre worklist, forecasts
  {
    path: "/call-centre",
    component: () => import(/* webpackChunkName: "analytics" */ "../views/analytics/CallCentre.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/forecasts",
    component: () => import(/* webpackChunkName: "analytics" */ "../views/analytics/Forecasts.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  // Disease tracking
  {
    path: "/disease-tracking",
    component: () => import(/* webpackChunkName: "analytics" */ "../views/analytics/DiseaseTracking.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/disease-tracking/:id",
    component: () => import(/* webpackChunkName: "analytics" */ "../views/analytics/DiseaseDetail.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  // Population & coverage
  {
    path: "/population",
    component: () => import(/* webpackChunkName: "analytics" */ "../views/analytics/Population.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  // Facilities with no enrollees (review / bulk disapprove)
  {
    path: "/providers/zero-enrollees",
    component: () => import(/* webpackChunkName: "providers" */ "../views/providers/ZeroEnrolleeFacilities.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  // Provider and establishment dashboards
  {
    path: "/providers/dashboard",
    component: () => import(/* webpackChunkName: "analytics" */ "../views/analytics/FacilitiesDashboard.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/establishments/dashboard",
    component: () => import(/* webpackChunkName: "analytics" */ "../views/analytics/EstablishmentDashboard.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  // Online payments (capitation and claims) and facilities' payout accounts
  {
    path: "/online-payments",
    component: () => import(/* webpackChunkName: "payments" */ "../views/payments/OnlinePayments.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/online-payments/run/:id",
    component: () => import(/* webpackChunkName: "payments" */ "../views/payments/PaymentRun.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/payout-account",
    component: () => import(/* webpackChunkName: "payments" */ "../views/payments/PayoutAccounts.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/loans",
    component: () => import(/* webpackChunkName: "payments" */ "../views/credit/Loans.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// Staff with the "dashboard" job title only use the dashboard view.
const DASHBOARD_ONLY_PATHS = ["/dashboard-view", "/pusher", "/user-settings"];
router.beforeEach((to, from, next) => {
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch (error) {
    user = null;
  }
  if (
    user && user.type == "employee" && user.job_title == "dashboard" &&
    localStorage.getItem("jwt") != null &&
    to.matched.some((route) => route.meta.requiresAuth) &&
    !DASHBOARD_ONLY_PATHS.includes(to.path) && !to.path.startsWith("/messages")
  ) {
    return next({ path: "/dashboard-view" });
  }
  next();
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((route) => route.meta.requiresAuth)) {
    if (localStorage.getItem("jwt") != null) {
      next();
    } else {
      next({ path: "/" });
    }
  }
  next();
});

export default router;
